import React, { useEffect, useState } from 'react';
import { FaUsers, FaCircle } from 'react-icons/fa';
import Navbar from '../../components/Navbar/Navbar';
import TeamMemberCard from '../../components/TeamBadge/TeamMemberCard';
import './Team.css';
import { functionsBase } from '../../config/functionsBase';

const FUNCTIONS_BASE = functionsBase('/.netlify/functions');

async function fetchTeam() {
  const res = await fetch(`${FUNCTIONS_BASE}/team`);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Erro ${res.status}`);
  }
  return data;
}

const Team = () => {
  const [members, setMembers] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let alive = true;
    setLoading(true);
    fetchTeam()
      .then((data) => {
        if (!alive) return;
        setMembers(data.members || []);
        setStats(data.stats || null);
        setError('');
      })
      .catch((err) => {
        if (!alive) return;
        setError(err.message || 'Não foi possível carregar a equipe');
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  const onlineCount = stats?.online ?? members.filter((m) => m.online).length;

  return (
    <div className="team">
      <Navbar />

      <section className="team-hero">
        <div className="team-hero__glow" aria-hidden="true" />
        <div className="team-hero__grid" aria-hidden="true" />
        <div className="team-wrap team-hero__content">
          <p className="team-hero__kicker">
            <FaUsers aria-hidden="true" /> Quem faz o Nexus
          </p>
          <h1 className="team-hero__brand">NEXUS</h1>
          <p className="team-hero__lead">
            A equipe por trás do servidor — administração, suporte, builders e mais.
          </p>
          {!loading && !error && members.length > 0 && (
            <p className="team-hero__meta">
              {onlineCount > 0 ? (
                <>
                  <FaCircle className="team-hero__dot" aria-hidden="true" />
                  {onlineCount} online no servidor agora
                </>
              ) : (
                `${members.length} membro${members.length === 1 ? '' : 's'} na equipe`
              )}
            </p>
          )}
        </div>
      </section>

      <section className="team-body">
        <div className="team-wrap">
          {loading && <p className="team-status">Carregando equipe…</p>}
          {!loading && error && <p className="team-status team-status--error">{error}</p>}
          {!loading && !error && !members.length && (
            <p className="team-status">A equipe ainda está sendo montada. Volte em breve.</p>
          )}

          <div className="team-grid">
            {members.map((member, index) => (
              <TeamMemberCard
                key={member.id}
                member={member}
                style={{ '--delay': `${Math.min(index, 8) * 60}ms` }}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Team;
